import { render, staticRenderFns } from "./disponibilidade-pecas.vue?vue&type=template&id=3708c0ae&scoped=true&"
import script from "./disponibilidade-pecas.vue?vue&type=script&lang=js&"
export * from "./disponibilidade-pecas.vue?vue&type=script&lang=js&"
import style0 from "./disponibilidade-pecas.vue?vue&type=style&index=0&id=3708c0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708c0ae",
  null
  
)

export default component.exports